var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-img',{staticClass:"logo",attrs:{"src":"/img/logo/light.png","contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }